module.exports = __webpack_public_path__ + "assets/builds/bundle.css";